(function() {
  const videoModule = $('.animateVideoModule');
  const videoContent = $('.animateVideoModule__content');

  $.jScrollability([
    {
      'selector': videoModule,
      'start': function($el) { return $el.offset().top + window.innerHeight },
      'end': function($el) { return $el.offset().top + $el.height() },
      'fn': function($el, pcnt) {
        let opacityScale = 0;

        if (pcnt >= 0.3) {
          videoModule.addClass('animateVideoModule--activeContent');
          opacityScale = 2;
        } else {
          videoModule.removeClass('animateVideoModule--activeContent');
          opacityScale = 0;
        }

        videoContent.css({
          'opacity': `${(pcnt - 0.3) * opacityScale}`,
          'padding-bottom': `${((pcnt - 0.3) * opacityScale) * 100}px`,
        });
      }
    }
  ]);
}());
